<template>
      <b-nav-item-dropdown right no-caret class="language-dropdown">
        <template slot="button-content">
          <a class="nav-link header-item mr-2">
            {{$t('CHANGELANGUAGE')}}
            <icon icon="chevron-down"></icon>
          </a>
        </template>
        <b-dropdown-item v-for="item in data.root" :key="item.langId" v-on:click="fetchLanguage(item.langId)"><a>{{$t(item.langName.toUpperCase())}}</a></b-dropdown-item>
      </b-nav-item-dropdown>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import Api from '@/api/admin/languages/TransLang.js';

export default
{
  name: 'header-dropdown-accnt',
  created: function()
  {
    var me = this;
    me.getData();
  },
  data: function()
  {
    return {
      data: {},
      pagination:
      {
        currentPage: 1,
        limit: 20
      }
    }
  },
  methods:
  {
    ...mapActions([
      'fetchLanguage'
    ]),
    async getData()
    {
        const me = this;
        try
        {
            const data = await Api.selectRow(me.pagination);
            if (data.error && data.error === true)
            {
                throw (data);
            }
            me.data = data;
        }
        catch (error)
        {
            me.$notify.notice(error);
        }
    },
  },
  computed:
  {
    ...mapGetters([
      'globals'
    ])
  }
}
</script>
